<template>
  <div :class="bemBlock">
    <h2 :class="bemElement('title')">
      {{
        customizerId === 'designer'
          ? $msg('designer.main.selector.title', 'customizer')
          : $msg('customizer.main.selector.title', 'customizer')
      }}
    </h2>
    <div :class="bemElement('products')">
      <TheProductCustomizerMain
        v-for="(product, i) in mainProducts"
        :key="`${product.id}-${i}`"
        :product="product"
        :reset="reset"
        :initially-selected="initialMainProductId === product.id"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import bemClassesMixin from '../../mixins/bemClassesMixin';
import TheProductCustomizerMain from './TheProductCustomizerMain.vue';
import { getters } from '../../store';

export default {
  name: 'TheProductCustomizerMainSelector',

  components: {
    TheProductCustomizerMain,
  },

  mixins: [bemClassesMixin],

  props: {
    reset: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      initialMainProductId: undefined,
    };
  },

  computed: {
    ...mapGetters({
      customizerId: getters.productCustomizer.customizerId,
      mainProducts: getters.productCustomizer.mainProducts,
    }),
  },

  mounted() {
    this.selectInitialMainProductId();
  },

  methods: {
    selectInitialMainProductId() {
      this.initialMainProductId = this.mainProducts.find(
        (product) => product.available
      )?.id;
    },
  },
};
</script>
